<footer class="footer">
  <div class="row">
    <div class="footerTabs col-sm-12">
      <ul class="footerTabs">
        <li *ngFor="let tab of menu.tabs">
          <a href="{{ tab.url }}"> {{ tab.title }}</a>
        </li>
        <li>
          <button class="ot-sdk-show-settings">Manage preferences</button>
        </li>
      </ul>
    </div>
    <div class="social-links col-sm-12">
      <ul *ngFor="let socialMenu of socialMenu.tabs">
        <li>
          <a href="{{ socialMenu.url }}" target="_blank" rel="noopener noreferrer"><img src="{{ socialMenu.title }}" alt="" /></a>
        </li>
      </ul>
    </div>
  </div>
  <p>© British Airways - all rights reserved</p>
  <div class="footer-images">
    <img alt="" src="https://images.ctfassets.net/nwnmkeyu03hy/4CgFKzFgnc1cgCISZBVMAm/b0cbc86ef389434c219182b52cfbd08d/ba_speedmarque.png" />
  </div>

</footer>
